import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateTemplateSharingMutation,
  UpdateTemplateSharingMutationVariables,
} from "./UpdateTemplateSharing.generated";

export const UPDATE_TEMPLATE_SHARING: TypedDocumentNode<
  UpdateTemplateSharingMutation,
  UpdateTemplateSharingMutationVariables
> = gql`
  mutation UpdateTemplateSharing(
    $templateUuid: String!
    $sharingType: String!
    $sharedEmails: [String!]
  ) {
    updateTemplateSharing(
      templateUuid: $templateUuid
      sharingType: $sharingType
      sharedEmails: $sharedEmails
    ) {
      ok
    }
  }
`;
